import { GRAPH_GROUP_NODE_LABEL_CLASS_NAME } from "Common/componentUtils/constants";
import React from "react";
import ReactDOMServer from "react-dom/server";
import { NODE_GROUP_MIN_SIZE } from "../../constants";
import buildGroupNodesTag from "./buildGroupNodesTag";
export default (graphComponentRef, node) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) ||
        !node ||
        !node.tag ||
        !node.tag.Nodes ||
        !node.tag.GroupId)
        return;
    const nodeCanvas = graphComponentRef.current.graphModelManager.getCanvasObject(node);
    if (!nodeCanvas)
        return;
    const labels = node.labels.toArray();
    if (labels.length !== 1) {
        labels.forEach(label => {
            var _a;
            ((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) && graphComponentRef.current.graph.remove(label);
        });
        const id = buildGroupNodesTag(node.tag.GroupId);
        const groupNodeLabelStyle = {
            width: Math.max(node.layout.width, NODE_GROUP_MIN_SIZE.width) - 2,
            height: Math.max(node.layout.height, NODE_GROUP_MIN_SIZE.height) - 2
        };
        const label = graphComponentRef.current.graph.addLabel(node, ReactDOMServer.renderToStaticMarkup(React.createElement("div", { className: GRAPH_GROUP_NODE_LABEL_CLASS_NAME, id: id, style: groupNodeLabelStyle })));
        label.tag = id;
        const labelCanvas = graphComponentRef.current.graphModelManager.getCanvasObject(label);
        nodeCanvas && (labelCanvas === null || labelCanvas === void 0 ? void 0 : labelCanvas.above(nodeCanvas));
    }
    else {
        const label = labels.at(0);
        if (label === null || label === void 0 ? void 0 : label.style) {
            const { renderCallback } = label.style;
            renderCallback === null || renderCallback === void 0 ? void 0 : renderCallback(graphComponentRef.current.canvasContext.canvasComponent, label);
        }
    }
};
